import { useTooltipAnchor } from '@/hooks/useTooltipAnchor'

import { Box, Tooltip } from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

interface DarkTooltipTextIProps {
  children: string
  colorScheme: ColorScheme
  dataTestId?: string
  label: string
}

export const DarkTooltipText = ({
  children,
  colorScheme,
  dataTestId,
  label,
}: DarkTooltipTextIProps) => {
  const { anchorEl, onMouseEnter, onMouseLeave } = useTooltipAnchor()

  return (
    <>
      <Box
        as='span'
        data-testid={dataTestId}
        display='block'
        minWidth={0}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        overflow='hidden'
        textOverflow='ellipsis'
        whiteSpace='nowrap'
      >
        {children}
      </Box>
      <Tooltip anchorEl={anchorEl} colorScheme={colorScheme} label={label} />
    </>
  )
}
